module.exports = __webpack_public_path__ + "img/cadastro-servicos.b5c8b26f.jpg";